// import React, { useState } from "react";
// import {
//   Button,
//   FormFieldSet,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../components";
// import { dateFormator, mapTableRows } from "../../../utils";

// import SalaryProfileConfigurationsModal from "./SalaryProfileConfigurations/Modals/SalaryprofileConfigurationsModal";
// import { useNavigate } from "react-router-dom";

// const SalaryProfileConfigurations = () => {
//   const [toggleStates, setToggleStates] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const navigate = useNavigate();

//   const handleToggleChange = (rowId) => {
//     setToggleStates((prev) => ({
//       ...prev,
//       [rowId]: !prev[rowId],
//     }));
//   };
//   const tableData = [
//     {
//       id: "1",
//       payProfileName: "W2 Payroll (Monthly)",
//       payCycle: "Monthly",
//       payDay: "2025-12-05T00:00:00.000Z",
//       nextPayDayPayCycle: "04/01/2025 - 04/30/2025",
//       linkedEmployees: "55",
//       status: true,
//     },
//   ];
//   const columns = [
//     {
//       key: "payProfileName",
//       label: "Pay Profile Name",
//     },
//     {
//       key: "payCycle",
//       label: "Pay Cycle",
//     },
//     {
//       key: "payDay",
//       label: "Pay Day",
//       render: (row) => dateFormator(row.payDay, "month-day-year"),
//     },
//     {
//       key: "nextPayDayPayCycle",
//       label: "Next Pay Day Pay Cycle",
//     },
//     {
//       key: "linkedEmployees",
//       label: "Linked Employees",
//     },
//     {
//       key: "status",
//       label: "Status",
//       render: (row) => (
//         <div>
//           <FormFieldSet
//             label={""}
//             title={""}
//             type="toggle"
//             size="sm"
//             // isChecked={formData?.enableBulkSubmison}
//             // value={formData?.enableBulkSubmison}
//             // onChange={() =>
//             //   handleChange("enableBulkSubmison", !formData.enableBulkSubmison)
//             // }
//             isChecked={toggleStates[row.id] || false}
//             value={toggleStates[row.id] || false}
//             onChange={() => handleToggleChange(row.id)}
//           />
//         </div>
//       ),
//     },

//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex gap-1">
//           <Button
//             type={"icon"}
//             icon={"edit_square"}
//             variant="text"
//             color="black"
//             size="xs"
//             onClick={() => {
//               setIsEditMode(true);
//               setEditData(row); // pass selected row
//               setIsModalOpen(true);
//             }}
//           />
//           <Button
//             type={"icon"}
//             icon={"history"}
//             variant="text"
//             color="black"
//             size="xs"
//           />
//         </div>
//       ),
//     },
//   ];

//   const handleAddClick = () => {
//     // setIsModalOpen(true);
//     setIsEditMode(false);
//     setEditData(null);
//     setIsModalOpen(true);
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//   };
//   return (
//     <div>
//       <PageHeader
//         Section={
//           <div className="flex my-3">
//             <PageTitle title={"Salary Profile Configurations"} tag="h6" />
//           </div>
//         }
//         RightSection={
//           <>
//             <Button
//               title="Back"
//               size="sm"
//               icon={"arrow_left_alt"}
//               onClick={() => navigate("/payroll")}
//             />
//             <Button
//               title="Add Pay Cycle"
//               size="sm"
//               icon={"add"}
//               onClick={handleAddClick}
//             />
//           </>
//         }
//       />

//       <div>
//         <NewTable
//           rows={tableData}
//           columns={columns}
//           toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//           customSection={
//             <div>
//               <Button title={"Search"} size="sm" />
//             </div>
//           }
//         />
//       </div>
//       <div>
//         <SalaryProfileConfigurationsModal
//           isOpen={isModalOpen}
//           onClose={handleModalClose}
//           isEditMode={isEditMode}
//           initialData={editData}
//         />
//       </div>
//     </div>
//   );
// };

// export default SalaryProfileConfigurations;

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CustomToggle,
  LogoLoader,
  TableAdv,
  PageHeader,
  PageTitle,
  ToggleButton,
  ToolTip,
} from "../../../components";
import { dateFormator } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import SalaryprofileConfigurationsModal from "./SalaryProfileConfigurations/Modals/SalaryprofileConfigurationsModal";
import { usePagination } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import { addNewSalaryPayConfig, getAllSalaryPayConfig } from "../../../redux/slices/payroll/payrollSlice";
import { SalaryProfileCycles } from "../../../assets/data/enumData";
const SalaryProfileConfigurations = () => {
    const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );
    const {loading,salaryPayConfig}=useSelector((state)=>state.payRoll);
      const isLoading=!!loading
       const [counts,setCounts]=useState({});
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.salaryprofile?.data || 0;
  const salaryPayConfigData=salaryPayConfig?.data||[]
  const [tableData, setTableData] = useState([
    {
      id: uuidv4(),
      payProfileName: "W2 Payroll (Monthly)",
      payCycle: "Monthly",
      payDay: "2025-12-05T00:00:00.000Z",
      nextPayDayPayCycle: "04/01/2025 - 04/30/2025",
      linkedEmployees: "55",
      status: true,
    },
    {
      id: uuidv4(),
      payProfileName: "Bi-Monthly(W2)",
      payCycle: "Semi Monthly",
      payDay: "2025-12-05T00:00:00.000Z",
      nextPayDayPayCycle: "04/01/2025 - 04/30/2025",
      linkedEmployees: "1",
      status: false,
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const navigate = useNavigate();

const handleToggleChange = (row, value) => {
   console.log("row:", row); // Log the full row to ensure it's being passed correctly
  console.log("uiid:", row?.uiid); // Check the uiid value
  if (!row || typeof value === "undefined") {
    console.error("Invalid input: row or value is undefined");
    return;
  }
  // Prepare the payload based on the value of 'status'
  const payload = [
    {
      type: "SET",
      value: {
        status: value === true ? 1 : value === false ? 2 : "", // 1 for true, 2 for false, empty string for invalid cases
      },
    },
  ];

  // Dispatch action to add new salary pay config
  dispatch(
    addNewSalaryPayConfig({
      coll: "SalaryProfile",
      uiid: row?.uiid, // Ensure uiid exists
      payload,
      onSuccess: () => {
        // Dispatch further actions on success
        dispatch(
          totalCountStart({
            collection: "salaryprofiles",
            coll: "SalaryProfile",
            tname: "salaryprofile",
          })
        );
        const filters={ "uiid": { "type": "AG_COUNT", "value": {"coll": "emppayconfigs", "target": "profile"} } }
        dispatch(
          getAllSalaryPayConfig({
            coll: "SalaryProfile",
            limit,  // Make sure 'limit' and 'page' are defined or passed in the context
            page,
            useAggregate:true,
            filters
          })
        );
      },
    })
  );
};


  const handleAddClick = () => {
    setIsEditMode(false);
    setEditData(null);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSave = (updatedRow) => {
    if (isEditMode) {
      // Update existing row
      setTableData((prevData) =>
        prevData.map((row) => (row.id === updatedRow.id ? updatedRow : row))
      );
    } else {
      // Create new row with a unique ID
      const newRow = {
        ...updatedRow,
        id: Date.now().toString(), // generate a unique ID
      };
      setTableData((prevData) => [...prevData, newRow]);
    }
  };

  const columns = [
    { key: "name", label: "Pay Profile Name" },
   {
  key: "payCycle",
  label: "Pay Cycle",
  render: (row) => {
    const findCycle = SalaryProfileCycles?.find((data) => data.value === row?.payCycle);
    const cycleLabel = findCycle ? findCycle.label : "";  // Fallback in case no matching cycle is found
    return (
      <div>
        {cycleLabel}
      </div>
    );
  }
},
    // {
    //   key: "payDay",
    //   label: "Pay Day",
    //   render: (row) => dateFormator(row.payDay, "month-day-year"),
    // },
    // { key: "nextPayDayPayCycle", label: "Next Pay Day Pay Cycle" },
    {
  key: "count",
  label: "Linked Employees",
  render: (row) => {
    return <div>{row?.count || 0}</div>;
  }
},
    {
      key: "status",
      label: "Status",
      render: (row) =>{
        const status=row?.status===1?true:row?.status===2?false:""
        return (
        <CustomToggle
          size="sm"
          // isChecked={status}
          value={status}
          onChange={(value) => handleToggleChange(row,value)}
          type="toggleNew"
          options={["On", "Off"]}
        />
      )
    }
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type={"icon"}
            icon={"edit_square"}
            variant="text"
            color="black"
            size="xs"
            onClick={() => {
              setIsEditMode(true);
              setEditData(row);
              setIsModalOpen(true);
            }}
          />

          <Button
            type={"icon"}
            icon={"history"}
            variant="text"
            color="black"
            size="xs"
            onClick={() => navigate("/payroll/salary-profile-view")}
          />
        </div>
      ),
    },
  ];
 useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "salaryprofiles",
        coll: "SalaryProfile",
        tname: "salaryprofile",
      })
    );
     const filters={ "uiid": { "type": "AG_COUNT", "value": {"coll": "emppayconfigs", "target": "profile"} } }
        dispatch(
          getAllSalaryPayConfig({
            coll: "SalaryProfile",
            limit,  // Make sure 'limit' and 'page' are defined or passed in the context
            page,
            useAggregate:true,
            filters
          })
        );
  }, [dispatch, page, limit]);
  // useEffect((salaryPayConfigData)=>{
  //   const filterUiids=salaryPayConfigData.filter((data)=>data.uiid).map((data)=>data.uiid);
  //      if(filterUiids.length>0){
  //       for(filterUiids in data){
  //         try{

  //         }catch(){

  //         }
  //       }
  //      }
  // },[salaryPayConfigData])
  return (
    <div>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Salary Profile Configurations"} tag="h6" />
          </div>
        }
        RightSection={
          <>
            <Button
              title="Back"
              size="sm"
              icon={"arrow_left_alt"}
              onClick={() => navigate("/payroll")}
            />
            <Button
              title="Add Pay Cycle"
              size="sm"
              icon={"add"}
              onClick={handleAddClick}
            />
          </>
        }
      />

      <TableAdv
        tableId={`payroll_salaryprofileconfiguration`}
        rows={salaryPayConfigData}
        columns={columns}
        totalCount={totalCount}
        serverPagination={true}
        toolbarRight={{
          search: true,
          add: [
            {
              component: (
                <div className="flex flex-wrap items-center">
                  <Button title={"Search"} size="sm" />
                </div>
              ),
            },
          ],
        }}
        // customSection={
        //   <div className="flex flex-wrap items-center">
        //     <Button title={"Search"} size="sm" />
        //   </div>
        // }
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
      />

      <SalaryprofileConfigurationsModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        isEditMode={isEditMode}
        initialData={editData}
        onSave={handleSave}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
      />
       <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default SalaryProfileConfigurations;
